import { MoveApiModel } from '@app/api/api-models/MoveApiModel';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CreateItemApiModel } from '@app/api/api-models/CreateItemApiModel';
import { PeFormApiModel, PeFormListApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class PeFormsService {
  public apiUrl = 'pe-forms';

  constructor(private readonly http: HttpClientService) {}

  public getList(): Observable<Array<PeFormListApiModel>> {
    return this.http.get<Array<PeFormListApiModel>>(`${this.apiUrl}/get-list`);
  }

  public getById(id: number): Observable<PeFormApiModel> {
    return this.http
      .get<PeFormApiModel>(`${this.apiUrl}/get/${id}`)
      .pipe(map((data) => new PeFormApiModel().deserialize(data)));
  }

  public move(model: MoveApiModel<number>): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/move`, model);
  }

  public add(model: CreateItemApiModel): Observable<PeFormApiModel> {
    return this.http.post<PeFormApiModel>(`${this.apiUrl}/create`, model);
  }

  public delete(id: number): Observable<Object> {
    return this.http.delete(`${this.apiUrl}/delete/${id}`);
  }

  public update(model: PeFormApiModel): Observable<PeFormApiModel> {
    return this.http
      .put<PeFormApiModel>(`${this.apiUrl}/update`, model)
      .pipe(map((data) => new PeFormApiModel().deserialize(data)));
  }
}
